// src/services/gameRuleService.js

import {
    ABILITY_SCORES,
    CLASSES,
    RACES,
    ALIGNMENTS,
    getAbilityModifier,
    getRacialIncrease,
    getBaseHitPoints,
    calculateTotalAbilityScore
  } from '../config/gameRules';
  
  export class GameRuleService {
    getAbilityScores() {
      return ABILITY_SCORES;
    }
  
    getClasses() {
      return CLASSES;
    }
  
    getRaces() {
      return RACES;
    }
  
    getAlignments() {
      return ALIGNMENTS;
    }
  
    calculateModifier(score) {
      return getAbilityModifier(score);
    }
  
    calculateTotalScore(baseScore, ability, race) {
      return calculateTotalAbilityScore(baseScore, ability, race);
    }
  
    calculateMaxHealth(constitutionScore, characterClass) {
      const baseHp = getBaseHitPoints(characterClass);
      const conModifier = this.calculateModifier(constitutionScore);
      return baseHp + conModifier;
    }
  
    calculateArmorClass(dexterityScore) {
      return 10 + this.calculateModifier(dexterityScore);
    }
  
    calculateInitiative(dexterityScore) {
      return this.calculateModifier(dexterityScore);
    }
  
    calculateProficiencyBonus(level = 1) {
      return 2; // At level 1
    }
  
    getAbilityDescription(ability) {
      return ABILITY_SCORES[ability]?.description || '';
    }
  
    getClassDescription(characterClass) {
      const classInfo = CLASSES.find(c => c.name === characterClass);
      return classInfo?.description || '';
    }
  
    getRaceDescription(race) {
      const raceInfo = RACES.find(r => r.name === race);
      return raceInfo?.description || '';
    }
  
    getAlignmentDescription(alignment) {
      const alignmentInfo = ALIGNMENTS.find(a => a.name === alignment);
      return alignmentInfo?.description || '';
    }
  
    getSuggestedAbilities(characterClass) {
      const classInfo = CLASSES.find(c => c.name === characterClass);
      return classInfo?.suggestedAbilities || [];
    }
  
    getRacialBonuses(race) {
      const bonuses = {};
      Object.entries(ABILITY_SCORES).forEach(([ability, data]) => {
        const bonus = data.racialIncreases[race];
        if (bonus) {
          bonuses[ability] = bonus;
        }
      });
      return bonuses;
    }
  
    validateCharacter(character) {
      const validations = {
        isValid: true,
        errors: []
      };
  
      // Validate required fields
      if (!character.name) {
        validations.errors.push('Character name is required');
      }
  
      if (!character.race) {
        validations.errors.push('Race is required');
      }
  
      if (!character.characterClass) {
        validations.errors.push('Class is required');
      }
  
      if (!character.alignment) {
        validations.errors.push('Alignment is required');
      }
  
      // Validate ability scores
      Object.keys(ABILITY_SCORES).forEach(ability => {
        const score = character[ability.toLowerCase()];
        if (!score || score < 3 || score > 20) {
          validations.errors.push(`${ability} must be between 3 and 20`);
        }
      });
  
      validations.isValid = validations.errors.length === 0;
      return validations;
    }
  }
  
  export const gameRuleService = new GameRuleService();